import type { RedoDnsRpcClient } from "@redotech/redo-dns-rpc/client";
import { createRedoDnsRpcClient } from "@redotech/redo-dns-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoDnsRpcClientContext: Context<RedoDnsRpcClient | undefined> =
  createContext<RedoDnsRpcClient | undefined>(undefined);
RedoDnsRpcClientContext.displayName = "RedoDnsRpcClientContext";

export function RedoDnsRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoDnsRpcClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoDnsRpcClient({
      baseURL: new URL(`${baseUrl}/dns-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);
  return (
    <RedoDnsRpcClientContext.Provider value={redoDnsRpcClient}>
      {children}
    </RedoDnsRpcClientContext.Provider>
  );
}
